import React from 'react';
import ReactDOM from 'react-dom';
import { Oval } from 'react-loader-spinner';
import { ACCENT_COLOR } from '../icons/svg/colors';
import styles from './loader.module.scss';

const Loader = () => ReactDOM.createPortal(
  <div className={styles.loader}>
    <Oval color={ACCENT_COLOR} />
  </div>,
  document.body,
);

export default Loader;
